<template>
    <ResultsNetworkBanner bannerType="warning" header="In network">
        <ApplicationTier :result="result" :tierLabel="currentPlanTierLabel" v-if="currentPlanIsTiered && result.tier" />
        <span>Your plan covers emergency dental care only, not preventative dental care. Review your plan's <a :href="buildDetailUrl(categoryTerm)" :data-card-rank="rank">{{ categoryTerm.toLowerCase() }} benefits</a> to see
            what's covered.
        </span>
    </ResultsNetworkBanner>
</template>
    
<script setup>

const props = defineProps({
    result: Object,
    rank: Number
})

const { benefitCategories, context, currentPlanTierLabel, currentPlanIsTiered } = useFCPModel()
const { buildUrl } = useUrls(context.value)

const buildDetailUrl = (categoryTerm) => {
    return buildUrl(`/fcp/csearch/benefits/?category=${categoryTerm}`)
}


const categoryTerm = benefitCategories?.value ? benefitCategories.value[0].category : null

</script>
    
<style scoped lang="scss">
@use '../../../assets/scss/breakpoints' as *;

b {
    margin-right: var(--spacing-xxs);
    margin-left: var(--spacing-xxs);
    @include small-up {
        width: auto;
    }
}

</style>